import { createFeature, createReducer, on } from '@ngrx/store';
import { AccessActions } from './access.actions';
import { PermissionMatrix, ProjectRole } from '../models/access.models';

export interface IAccessState {
  /** Проект, для которого загружена матрица (null — ничего не загружено). */
  projectId: number | null;
  /** Роль текущего пользователя в проекте (для UI, enforcement — на бэке). */
  role: ProjectRole | null;
  /** Плоская матрица эффективных прав `{"section.action": bool}`. */
  matrix: PermissionMatrix;
  loading: boolean;
  loaded: boolean;
}

export const initialAccessState: IAccessState = {
  projectId: null,
  role: null,
  matrix: {},
  loading: false,
  loaded: false,
};

export const accessFeature = createFeature({
  name: 'access',
  reducer: createReducer(
    initialAccessState,
    on(AccessActions.loadPermissions, (state, { projectId }) => {
      // Смена проекта — сбрасываем матрицу, чтобы не использовать права прошлого проекта.
      const sameProject = state.projectId === projectId;
      return {
        ...state,
        projectId,
        loading: true,
        loaded: sameProject ? state.loaded : false,
        matrix: sameProject ? state.matrix : {},
        role: sameProject ? state.role : null,
      };
    }),
    on(AccessActions.loadPermissionsSuccess, (state, { projectId, matrix, role }) => ({
      ...state,
      projectId,
      matrix,
      role,
      loading: false,
      loaded: true,
    })),
    on(AccessActions.loadPermissionsFailure, (state, { projectId }) => ({
      ...state,
      projectId,
      matrix: {},
      role: null,
      loading: false,
      loaded: true,
    })),
    on(AccessActions.clearPermissions, () => ({ ...initialAccessState })),
  ),
});

export const {
  name: accessFeatureKey,
  reducer: accessReducer,
  selectAccessState,
  selectMatrix,
  selectRole,
  selectProjectId,
  selectLoaded,
  selectLoading,
} = accessFeature;
